import styled from 'styled-components';

const ToastContainer = styled.div`
  position: absolute;
  bottom: 0;
  padding:0;
  left: 0;
  background : none;
  width: 100%;
  pointer-events: none;
  display: flex;
  flex-direction: column;
`;

export default ToastContainer;
